import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { CalendarSolidIcon } from '@lean-body/components/atoms';
import { AiIcon } from '../atoms/icons/ai_icon';
export const GoalMatchingAssessmentResultConfirm = ({ classObject, config, userName, isWeightKeeping, result, goalDate, }) => {
    return (React.createElement("div", { className: css(styles.result, classObject) },
        React.createElement("div", { className: css(styles.resultContent) },
            React.createElement("div", { className: css(styles.resultTitle) },
                React.createElement(AiIcon, { classObject: styles.goalIcon }),
                React.createElement("div", { className: css(styles.titleText) },
                    userName,
                    "\u3055\u3093\u306E\u76EE\u6A19")),
            React.createElement("div", { className: css(styles.resultValue) }, isWeightKeeping ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: css(styles.currentWeight) },
                    React.createElement("div", { className: css(styles.currentWeightNumber) }, result.weightGoal),
                    React.createElement("div", { className: css(styles.currentWeightUnit) }, "kg")),
                React.createElement("div", { className: css(styles.currentWeightText) }, "\u3092\u7DAD\u6301\u3059\u308B"))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: css(styles.goalDate) },
                    React.createElement(CalendarSolidIcon, null),
                    React.createElement("div", { className: css(styles.goalDateText) },
                        React.createElement("div", { className: css(styles.dateNumber) }, goalDate.year()),
                        "\u5E74",
                        React.createElement("div", { className: css(styles.dateNumber) }, goalDate.month() + 1),
                        "\u6708",
                        React.createElement("div", { className: css(styles.dateNumber) }, goalDate.date()),
                        "\u65E5\u307E\u3067\u306B")),
                React.createElement("div", { className: css(styles.weightGoal) },
                    React.createElement("div", { className: css(styles.weightGoalNumber) }, result.weightGoal),
                    React.createElement("div", { className: css(styles.weightGoalUnit) }, "kg"))))),
            React.createElement("div", { className: css(styles.resultDetail) },
                React.createElement("div", { className: css(styles.detailHeader) }, "1\u65E5\u306E\u76EE\u6A19"),
                React.createElement("div", { className: css(styles.detailBody) }, result.dailyGoals.map((v, i) => (React.createElement("div", { className: css(styles.detailRow), key: i },
                    React.createElement("img", { className: css(styles.detailIcon), src: v.iconURL(config) }),
                    React.createElement("div", { className: css(styles.detailText) },
                        React.createElement("div", { className: css(styles.detailTitle) }, v.name),
                        React.createElement("div", { className: css(styles.detailValue, v.unit && styles.detailValueWithUnit) },
                            React.createElement("div", { className: css(styles.detailNumber, v.unit && styles.detailNumberWithUnit) }, v.value),
                            React.createElement("div", { className: css(styles.detailUnit) }, v.unit)))))))),
            React.createElement("div", { className: css(styles.annotation) }, "\u76EE\u6A19\u306F\u3044\u3064\u3067\u3082\u5909\u3048\u3089\u308C\u307E\u3059\u3002\u4E00\u7DD2\u306B\u3001\u697D\u3057\u304F\u7D9A\u3051\u307E\u3057\u3087\u3046\uFF01"))));
};
const styles = StyleSheet.create({
    result: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100%',
    },
    goalIcon: {
        width: 40,
        height: 40,
    },
    resultContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 30,
        [MediaBreakPointUp.MD]: {
            padding: '0 20px',
        },
    },
    resultTitle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
    },
    resultValue: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    resultDetail: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '100%',
        borderRadius: 10,
        [MediaBreakPointUp.MD]: {
            width: 327,
        },
    },
    titleText: {
        color: Colors.Black,
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.6,
    },
    currentWeight: {
        display: 'flex',
        alignItems: 'center',
        height: 50,
        fontWeight: 'bold',
        lineHeight: '140%',
    },
    currentWeightNumber: {
        fontSize: 36,
        letterSpacing: 1.44,
    },
    currentWeightUnit: {
        fontSize: 14,
        letterSpacing: 0.56,
        marginTop: 10,
    },
    currentWeightText: {
        height: 25,
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.44,
    },
    goalDate: {
        display: 'flex',
        alignItems: 'center',
        height: 28,
        gap: 8,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    goalDateText: {
        display: 'flex',
        alignItems: 'flex-end',
        height: '100%',
    },
    dateNumber: {
        fontSize: 20,
        letterSpacing: 0.8,
        marginBottom: 2,
    },
    weightGoal: {
        display: 'flex',
        alignItems: 'center',
        height: 45,
        fontWeight: 'bold',
        lineHeight: '140%',
    },
    weightGoalNumber: {
        fontSize: 32,
        letterSpacing: 1.28,
    },
    weightGoalUnit: {
        fontSize: 14,
        letterSpacing: 0.56,
        marginTop: 10,
    },
    detailHeader: {
        backgroundColor: Colors.Accent,
        color: Colors.White,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.12,
        width: '100%',
        height: 34,
        padding: '6px 0',
        borderRadius: '10px 10px 0 0',
    },
    detailBody: {
        backgroundColor: Colors.White,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 14,
        padding: '14px 20px 20px',
        borderRadius: '0 0 10px 10px',
        borderRight: `2px solid ${Colors.Accent}`,
        borderBottom: `2px solid ${Colors.Accent}`,
        borderLeft: `2px solid ${Colors.Accent}`,
    },
    detailRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    detailIcon: {
        width: 32,
        height: 32,
    },
    detailText: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },
    detailTitle: {
        color: Colors.GrayDarkest,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: 0.48,
        height: 19,
    },
    detailValue: {
        display: 'flex',
        alignItems: 'center',
        height: 19,
        lineHeight: '160%',
    },
    detailValueWithUnit: {
        height: 32,
    },
    detailNumber: {
        fontSize: 12,
        fontWeight: 'bold',
        letterSpacing: 0.8,
    },
    detailNumberWithUnit: {
        fontSize: 20,
        letterSpacing: 0.48,
    },
    detailUnit: {
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: 0.48,
    },
    annotation: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: 0.64,
        width: '100%',
    },
});
